const initialState = false;

const notificationReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_HAS_READ_NOTIFICATION':
            return action.payload;
        default:
            return state;
    }
};

export const setHasReadNotification = (value) => ({
    type: 'SET_HAS_READ_NOTIFICATION',
    payload: value,
});

export default notificationReducer;
